import { atom } from "recoil";
export const IsIntgCalRecoil = atom({
    key: "IsGetEventsGate",
    default: false,
});
export const instructionDataRecoil = atom({
    key: "instructionDataRecoil",
    default: {},
});
export const isLiveProcWarningModalOpenRecoil = atom({
    key: "isLiveProcWarningModalOpenRecoil",
    default: false,
});
export const evaluationConfigRecoil = atom({
    key: "evaluationConfigRecoil",
    default: {},
});
export const isUploaderModalOpenRecoil = atom({
    key: "isUploaderModalOpenRecoil",
    default: false,
});
export const videoMaxLengthCountRecoil = atom({
    key: "videoMaxLengthCountRecoil",
    default: 0,
});
export const videoCurrentLengthCountRecoil = atom({
    key: "videoCurrentLengthCountRecoil",
    default: 0,
});
